import RadioControl from '@/features/ui/inputs/components/RadioButton/parts/RadioControl'
import { stylesheet } from '@/features/ui/inputs/components/RadioButton/styles'
import { RadioButtonProps } from '@/features/ui/inputs/components/RadioButton/types'
import Typography from '@/features/ui/typography'
import { Pressable } from 'react-native'
import { useStyles } from 'react-native-unistyles'

const RadioButton = <T extends string>({
    value,
    label,
    disabled = false,
    error = false,
    checked = false,
    onPress,
    style,
}: RadioButtonProps<T>) => {
    const { styles } = useStyles(stylesheet, { disabled, checked })

    return (
        <Pressable
            disabled={disabled}
            onPress={() => onPress(value)}
            style={[styles.container, style]}
        >
            <RadioControl checked={checked} disabled={disabled} error={error} />
            <Typography.Label style={styles.label}>{label}</Typography.Label>
        </Pressable>
    )
}

export default RadioButton
